export default __webpack_public_path__ + "static/media/profile-form-phone.bcca7f3e.svg";